import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from '@mui/material';
import { MaterialBoolControl, TimeFieldInput, } from 'console/shared/components/fields';
import { SettingCard } from 'console/device-settings/z3k/components/material-utils/settings-card/card';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card/full-row';
import { ControlWithoutValidation } from 'console/shared/components/fields/control/without-validation';
export function TimeTable(props) {
    const weekday_register = props.value.weekday_register;
    const cbList = useMemo(() => new Array(7).fill(0).map((_, i) => {
        const shift = 1 << i;
        return (_jsx(TableCell, { children: _jsx(Checkbox, { checked: (weekday_register & shift) > 0, onChange: () => {
                    props.onChange({
                        ...props.value,
                        weekday_register: weekday_register ^ shift,
                    });
                }, disabled: !props.value.checked }) }, i));
    }), [weekday_register, props.value]);
    const _value = useMemo(() => ({
        min: props.value.time & 0x00ff,
        hour: (props.value.time & 0xff00) >> 8,
    }), [props.value.time]);
    const field = useCallback((input_props) => (_jsx(TimeFieldInput, { disabled: !props.value.checked, inputProps: {
            min: '00:00',
            max: '23:59',
        }, ...input_props })), [props.value.checked]);
    const _onChange = useCallback(({ min, hour }) => {
        props.onChange({
            checked: props.value.checked,
            weekday_register: props.value.weekday_register,
            time: (+hour << 8) + +min,
        });
    }, [props.onChange, props.value]);
    const onChangeChecked = useCallback((checked) => props.onChange({ ...props.value, checked }), [props.value, props.onChange]);
    return (_jsxs(SettingCard, { title: "", children: [_jsx(MaterialBoolControl, { value: props.value.checked, onChange: onChangeChecked, label: "\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u043F\u043E \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044E", help_id: "output_actions_timetable" }), _jsx(ControlWithoutValidation, { label: "\u0412\u0440\u0435\u043C\u044F", value: _value, onChange: _onChange, field: field }), _jsx(SettingFullRow, { children: _jsx(TableContainer, { children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsx(TableRow, { children: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map((name) => (_jsx(TableCell, { variant: "head", align: "center", children: name }, name))) }) }), _jsx(TableBody, { children: _jsx(TableRow, { children: cbList }) })] }) }) })] }));
}
